import { render, staticRenderFns } from "./PhoneBtn.vue?vue&type=template&id=1ce74b10&scoped=true&"
import script from "./PhoneBtn.vue?vue&type=script&lang=js&"
export * from "./PhoneBtn.vue?vue&type=script&lang=js&"
import style0 from "./PhoneBtn.vue?vue&type=style&index=0&id=1ce74b10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce74b10",
  null
  
)

export default component.exports